module.exports = __webpack_public_path__ + "img/智慧城管渣土综合监管平台V1.0.8b88fc08.jpg";